import { create } from 'zustand';

export const use3DEditingStore = create((set) => ({
  isEditing3D: false,
  setIsEditing3D: (isEditing3D) => set({ isEditing3D }),
}));

// See "Keeping a 3D slot selected through a photo upload" in common/AGENTS.md.
export function shouldKeepSlotSelectedDuringUpload() {
  const slot = window.activeView?.selected;
  return !!(use3DEditingStore.getState().isEditing3D && slot?.isImage);
}
